import { render, staticRenderFns } from "./AccountsReports.vue?vue&type=template&id=1dfefa88"
import script from "./AccountsReports.vue?vue&type=script&lang=js"
export * from "./AccountsReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports